import React from "react";

import { Button } from "@xometry/xometry_loft";

const BackButton = () => (
  <Button kind="primary" size="large" onClick={() => window.history.back()}>
    Back to previous page
  </Button>
);

export default BackButton;
